<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconGroup_24"
    viewBox="0 0 25 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15.818 3.716c2.409 0 4.368 1.951 4.368 4.348 0 2.4-1.96 4.35-4.368 4.35s-4.369-1.95-4.369-4.35c0-2.398 1.96-4.348 4.37-4.348M9.195 9.34a3.167 3.167 0 0 1-3.17 3.156A3.166 3.166 0 0 1 2.857 9.34a3.167 3.167 0 0 1 3.17-3.155 3.166 3.166 0 0 1 3.17 3.155m-3.17 4.505c1.272 0 2.276.14 3.083.368-.613.348-1.168.741-1.61 1.221-.331.358-.986 1.082-1.306 2.566H.917a.863.863 0 0 1-.856-.987c.15-.959.51-1.347.732-1.588l.021-.023c.822-.892 2.383-1.557 5.212-1.557M8.776 20H22.86c.724 0 1.29-.648 1.177-1.361-.21-1.339-.718-1.88-1.047-2.23l-.02-.021c-1.139-1.214-3.287-2.115-7.153-2.115-3.899 0-6.05.917-7.182 2.146l-.028.03c-.306.332-.802.867-1.01 2.19A1.19 1.19 0 0 0 8.777 20"
        clip-rule="evenodd"
    />
</svg>
